import { matches, useForm } from "@mantine/form"
import { httpsCallable } from "firebase/functions"

import { useCloudFunction } from "../../../hooks/useCloudFunction"
import { firebase } from "../../../services/firebase/firebase"
import { AwsIotCreateGroupData } from "../../../functions/aws/iot/aws-iot-createGroup"
import { useAuth } from "../../../contexts/authentication-context"
import { useLanguage } from "../../../contexts/language-context"

export default (onClose: () => void) => {
    const { onStart, onSuccess, onError, processing } = useCloudFunction("aws-iot-createGroup")
    const { user } = useAuth()
    const { L } = useLanguage()
    const form = useForm({
        initialValues: { name: "", description: "" },
        validate: {
            name: matches(
                /^[A-Z][a-z0-9-]{1,15}$/,
                L(
                    "Must contain only letters, numbers or hyphens, start with a capital and be no more than 16 characters long",
                ),
            ),
        },
        validateInputOnChange: true,
    })

    const onSubmit = (values: typeof form.values) => {
        if (user) {
            onStart(L("Creating group..."))
            httpsCallable<AwsIotCreateGroupData>(
                firebase.functions,
                "aws-iot-createGroup",
            )({
                name: values.name,
                organisation: user.organisation,
                ...(values.description && { description: values.description }),
            })
                .then(onSuccess(L("Group created successfully!")))
                .then(onClose)
                .catch(onError(L("Something went wrong whilst %s!", L("creating the group"))))
        }
    }

    return { form, onSubmit, processing }
}
